import { auth } from "../../../backend/firebaseConfig";

const API_URL = (process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001")
  .replace(/\/$/, "");

export const getProviderMatches = async ({
  page = 1,
  pageSize = 250,
  incomePeriodId = "",
  search = "",
  sort = "MatchedAt",
  direction = "desc",
  exportAll = false,
  userEmail = "",
} = {}) => {
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) throw new Error("Please sign in again.");
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    sort,
    direction,
  });
  if (incomePeriodId) params.set("incomePeriodId", incomePeriodId);
  if (search.trim()) params.set("search", search.trim());
  if (exportAll) params.set("export", "true");
  const response = await fetch(`${API_URL}/api/provider-matches?${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-User-Email": userEmail || "",
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "Unable to load provider matches.");
  return body;
};
